import moment from 'moment'
import * as R from 'ramda'

import {
  DEADLINE_FIELD,
  KIND_FIELD,
  MESSAGE_FIELD,
  MESSAGES_FIELD,
  RECEIVER_FIELD,
  SENDER_FIELD,
  SUBJECT_FIELD,
  TEMPLATE_ID_FIELD,
  STATUSES,
  getTemplate,
} from './model'

export const mapPropsToInternalState = state => {
  const {
    candidates = [],
    company,
    deadline,
    name: projectName,
    templates = [],
  } = state ?? {}

  return {
    [MESSAGES_FIELD]: R.map(
      ({ timestamps = {}, email, id, language, name, quiz_url, status }) => {
        const template = getTemplate({ language, status, templates })

        const term = moment(timestamps?.deadline || deadline).format(
          'YYYY-MM-DD',
        )

        return {
          key: id,
          [DEADLINE_FIELD]: term || '',
          [KIND_FIELD]: STATUSES[status] || '',
          [RECEIVER_FIELD]: email,
          [SENDER_FIELD]: template?.sender_name || '',
          [SUBJECT_FIELD]: R.pipe(
            R.replace(/\{{2}\s*\w+\s*\}{2}/g, match => {
              if (R.includes('project', match)) return projectName

              return match
            }),
            R.trim,
          )(template?.subject || ''),
          [MESSAGE_FIELD]: R.pipe(
            R.replace(/(\{{2} \w* \}{2})/g, match => {
              if (R.includes('name', match)) return name
              if (R.includes('company', match)) return company
              if (R.includes('deadline', match))
                return moment(term)
                  .locale(language)
                  .format('LL')
              if (R.includes('url', match)) return quiz_url

              return match
            }),
            R.trim,
          )(template?.body || ''),
          [TEMPLATE_ID_FIELD]: template?.id || '',
        }
      },
      candidates,
    ),
  }
}
